export const TIER_CONTENT_DEVIATIONS_STREAM_GROUP_ID = 'tierContent';

export const TIER_CONTENT_DEVIATIONS_PER_FETCH = 12;

export const getTierContentDeviationsStreamId = (
  section: 'deviations' | 'posts'
): string =>
  `${TIER_CONTENT_DEVIATIONS_STREAM_GROUP_ID}_${section}_ids_stream`.toUpperCase();
